export const LOCALES = Object.freeze({
  en: 'English',
  cn: '中文',
  kr: '한국어',
  in: 'Indonesian',
  ru: 'Россия',
  tr: 'Türkiye',
  vi: 'Việt nam',
})

const LOCALES_HTML = Object.freeze({
  // just different ones
  en: 'en',
  cn: 'zh-Hans',
  tw: 'zh-Hant',
  kr: 'ko',
  vn: 'vi',
})

const LOCALES_TRADINGVIEW = Object.freeze({
  // just different ones
  en: 'en',
  cn: 'zh',
  tw: 'zh_TW',
  kr: 'ko',
  ru: 'ru',
  vn: 'vi',
  nl: 'nl_NL',
})

const LOCALES_CALENDAR = Object.freeze({
  en: 'en',
  cn: 'zh-CN',
  tw: 'zh-TW',
  kr: 'ko',
  ru: 'ru',
  vn: 'vi',
  nl: 'nl-NL',
  pt: 'pt',
})

const LOCALES_SUPPORT = Object.freeze({
  en: 'en-us',
  cn: 'zh-cn',
  tw: 'zh-tw',
  kr: 'ko',
  ru: 'ru',
  vn: 'vi',
  it: 'it',
  es: 'es',
  de: 'de',
  fr: 'fr',
})

export const getHtmlLang = (locale = 'en') => LOCALES_HTML[locale] || locale

export const getTradingViewLocale = (locale = 'en') => LOCALES_TRADINGVIEW[locale] || locale

export const getCalendarLocale = (locale = 'en') => LOCALES_CALENDAR[locale] || locale

export const getSupportLocale = (locale = 'en') => LOCALES_SUPPORT[locale] || locale
